import { AlgoliaObject } from '@marmon/shared/types/algolia';
import { Organization } from '@marmon/shared/types/organization';
import { Group } from '../interfaces';
import { organizationsForGroup } from '../utils/algolia-group.utils';

export class AlgoliaGroup extends AlgoliaObject {
	name!: string;
	organizationIds!: string[];
	organizationNames!: string[];
	leaderIds!: string[];

	constructor(base: Group, organizations: Organization[] = []) {
		super(base);

		this.name = base.name;
		this.leaderIds = (base.leaders ?? []).map((leader) => leader.id);

		const organizationsById = new Map(
			organizations.map((org) => [org.id, org]),
		);
		const resolved = organizationsForGroup(base, organizationsById);

		this.organizationIds = resolved.map((org) => org.id);
		this.organizationNames = resolved.map((org) => org.name);
	}

	/**
	 * Determines if this algolia group instance is equal to another one. We avoid
	 * checking against the created and updated timestamps due to those values not holding
	 * any merit or value in terms of the Algolia data object.
	 */
	isEqual(other: AlgoliaGroup) {
		if (other.objectID !== this.objectID) return false;
		if (other.name !== this.name) return false;
		if (
			JSON.stringify(other.organizationIds) !==
			JSON.stringify(this.organizationIds)
		) {
			return false;
		}
		if (
			JSON.stringify(other.organizationNames) !==
			JSON.stringify(this.organizationNames)
		) {
			return false;
		}
		if (
			JSON.stringify(other.leaderIds) !== JSON.stringify(this.leaderIds)
		) {
			return false;
		}

		return true;
	}
}
